import { useAppSelector } from '../../redux';
import TrailPolyline from './TrailPolyline';

const ActiveTrailPolylines = ({ maxPolylines }: { maxPolylines?: number }) => {
  const { activeTrails } = useAppSelector(state => ({ activeTrails: state.map.activeTrails }));

  if (!activeTrails) {
    return null;
  }

  return <>{activeTrails.slice(0, maxPolylines).map(trail => trail && <TrailPolyline key={trail.ID} trail={trail} />)}</>;
};

export default ActiveTrailPolylines;
